import React, { useEffect, useState } from "react";
import { classNames } from "../../helpers/classNames";

const Tabs = ({
  tabs,
  tabContainerClass,
  tabNavClass,
  tabButtonClass,
  tabButtonActiveClass,
  tabContentClass,
  setSelected = () => {},
  ...props
}) => {
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  const handleTabSelection = (tab = {}) => {
    setSelectedTab(tab); // updates local UI immediately
    setSelected(tab._id); // not delayed, parent gets notified
  };

  useEffect(() => {
    if (tabs) {
      setSelectedTab(tabs[0]);
    }
  }, [tabs?.length]);

  return (
    <>
      <div
        className={classNames(
          "relative flex flex-col items-start",
          tabContainerClass
        )}
      >
        <nav
          className={classNames(
            "flex overflow-auto gap-2 max-w-full",
            tabNavClass
          )}
        >
          {tabs.map((item, index) => (
            <button
              type="button"
              className={classNames(
                "relative rounded-t-2xl transition-all duration-200 px-4 h-12 whitespace-nowrap text-base font-medium",
                tabButtonClass,
                item._id === selectedTab?._id
                  ? classNames(
                      "bg-chestnut-rose text-white",
                      tabButtonActiveClass
                    )
                  : "bg-shades-04 text-gable-green"
              )}
              key={index}
              onClick={() => handleTabSelection(item)}
            >
              {item.name}
            </button>
          ))}
        </nav>
        <div
          className={classNames(
            "relative rounded-2xl !rounded-tl-none bg-white py-4",
            tabContentClass
          )}
        >
          {selectedTab?.component}
        </div>
      </div>
    </>
  );
};

export default Tabs;
